// GENERATED — do not edit. Imports iconNode/paint/viewBox from the sibling .data.ts.

import { createIcon } from "../../../internal/createIcon";
import { iconNode, paint, viewBox } from "./BoardIcon.data";

export const BoardIcon = createIcon("BoardIcon", iconNode, { paint, viewBox });
